module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/notificacion/notificacion.component.html
// module id = ./src/app/notificacion/notificacion.component.html
// module chunks = main